import { BasicClient } from '@/utils/httpClient'

export default class PerformanceIntegration {
  client: BasicClient
  constructor() {
    this.client = new BasicClient()
  }

  async checkIntegrationPerformance() {
    return false
  }
}